module.exports = __webpack_public_path__ + "img/36.9.TU.fd82effa.png";